import TagMappingsScreen from "../../TagMappings";
import { TAG_DOMAIN_ENUM } from "../../TagMappings/helper";

/**
 * Tag mappings as they apply to external problems: the tags the six judges
 * publish, our own tag for each of them, and the canonical tags we added that
 * no judge publishes.
 *
 * The same screen as the product-wide Tag Mappings page, pinned to this product
 * line so its type controls disappear and the fields external problems record
 * against a mapping render as columns. Everything the screen does, and every
 * rule about what an empty canonical tag means, lives in
 * `components/TagMappings`.
 *
 * @param {object} props
 * @param {string} props.ROOT_URL
 * @param {boolean} props.hasManagementAccess - False leaves the screen read-only, matching the
 *   admin's `externalProblems.hasManagementAccess` permission.
 */
const TagMappings = ({ ROOT_URL, hasManagementAccess }) => (
  <TagMappingsScreen
    ROOT_URL={ROOT_URL}
    pinnedTagDomain={TAG_DOMAIN_ENUM.EXTERNAL_PROBLEM}
    hasManagementAccess={hasManagementAccess}
  />
);

export default TagMappings;
